import {
  getTextResponsesRequest,
  getTextResponsesResponse,
} from '@core-api/presentation/presentation/questions/{admin_key}/text-responses';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchTextResponsesParams {
  adminKey: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchTextResponses = ({
  adminKey,
  shouldFetchResults,
  sessionId,
}: UseFetchTextResponsesParams) => {
  const requestParams = { adminKey };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey(adminKey, sessionId)
    : null;
  const shouldMakeRequest = shouldFetchResults && !!adminKey;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldMakeRequest,
    sessionId,
    getRequest: getTextResponsesRequest,
    getResponse: (response) =>
      getTextResponsesResponse(response, { enableStatusCheck: false }),
  });
};
